import styled from 'styled-components'

export const StyledForm = styled.div`
    flex: 1 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        width: 434px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints[2]}}) {
        .form__radio-button {
            margin-top: 16px;
        }
    }

    form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        form {
            display: initial;
            height: initial;
        }
    }

    .form__radio-female,
    .form__radio-male,
    .form__radio-intersex {
        padding: 20px 0;
    }

    .divider {
        width: 100%;
        border: 1px solid rgba(22, 22, 22, 0.24);
    }
`
